<template>
  <v-container fluid>
    <v-spacer></v-spacer>
    <!-- {{ happ }} -->
    <!-- font-weight-bold font-weight-bold -->
    <v-card elevation="12">
      <v-card-title class="subheading"
        >{{happ[0].HappShortName}}<v-spacer></v-spacer>
        <label>From: {{ happ[0].StartStringDate }}</label>
        <v-spacer></v-spacer>
        <label>To: {{ happ[0].EndStringDate }}</label>
        <v-spacer></v-spacer>
      </v-card-title>
      <!-- <v-row class="d-flex justify-space-around align-center mb-6">
        <label>From: {{ happ[0].StartStringDate }}</label>
        <label>To: {{ happ[0].EndStringDate }}</label>
      </v-row> -->
    </v-card>
    <!-- class="white--text align-end" -->
    <div>.</div>
    <v-row class="d-flex align-center mb-6">
      <!-- <v-spacer></v-spacer> -->
      <v-col>
        <!-- <v-card
          height="120"
          width="160"
          class="d-flex justify-space-around align-center mb-6"
          elevation="12"
        >
          <label>Left small info</label>
        </v-card> -->
      </v-col>
      <v-spacer></v-spacer>
      <v-col>
        <v-card width="160" elevation="12">
          <v-img :src="happ[0].FlagUrl" height="120">
            <v-card-title class="d-flex justify-center"
              ><v-chip v-text="happ[0].LocationName"></v-chip
            ></v-card-title>
            <!-- <v-chip v-text="happ[0].LocationName"></v-chip> -->
            <v-card-actions class="d-flex justify-center">
              <a
                :href="happ[0].GoogleMapLink"
                target="_blank"
                v-if="happ[0].HasPosition"
                ><v-btn
                  v-if="happ[0].HasPosition"
                  color="primary"
                  rounded
                  small
                  class="d-flex justify-center"
                  >Google
                  <v-icon small right>mdi-map</v-icon>
                </v-btn></a
              >
            </v-card-actions>
          </v-img>
        </v-card>
      </v-col>
      <v-spacer></v-spacer>
      <v-col>
        <!-- <v-card
          height="120"
          width="160"
          class="d-flex justify-space-around align-center mb-6"
          elevation="12"
        >
          <label>Right small info</label>
        </v-card> -->
      </v-col>
    </v-row>
    <v-card elevation="12">
      <!-- <v-main> -->
      <!-- <v-spacer></v-spacer> -->
      <!-- <v-textarea auto-grow shaped outlined :value="happ[0].Description"></v-textarea> -->
      <v-row>
        <v-col cols="1"></v-col>
        <v-col><div v-html="happ[0].Description"></div></v-col>

        <v-col cols="1"></v-col>
      </v-row>
      <!-- </v-main> -->
      <v-card-actions class="d-flex justify-center">
        <a
          :href="happ[0].MoreInfoUrl"
          target="_blank"
          v-if="happ[0].HasMoreInfo"
          ><v-btn
            v-if="happ[0].HasMoreInfo"
            color="primary"
            rounded
            small
            class="d-flex justify-center"
            >More Info
            <v-icon small right>mdi-information</v-icon>
          </v-btn></a
        >
      </v-card-actions>
    </v-card>
    <v-divider></v-divider>
    <div>.</div>
    <v-card elevation="12">
      <v-spacer></v-spacer>
      <v-row>
        <v-col cols="1"></v-col>
        <v-col>
          <v-img :src="happ[0].ImgUrl" width="400"></v-img>
        </v-col>
        <v-col cols="1"></v-col>
      </v-row>
      <v-spacer></v-spacer>
    </v-card>
    <div>.</div>
    <v-divider></v-divider>
    <v-card
      class="d-flex justify-space-around align-center mb-6"
      elevation="12"
    >
      <label>{{ happ[0].HappOwner }}</label>
    </v-card>
    <!-- </div> -->
  </v-container>
</template>

<script>
export default {
  name: "HappDetails",
  props: {
    happ: {
      type: Array,
    },
    regId: Number,
    ac: String,
  },
  data() {
    return {
      //   search: "",
      items: [],
      loading: true,
      //   dialog: false,
      //   pid: null,
    };
  },
  created() {
    //
    this.items = this.happ;
    this.loading = false;
    // console.log("In component",this.happ);
  },
};
</script>
